import * as React from "react";

export type ToastType = "success" | "error";

export interface IToastProps {
    visible: boolean;
    message: string;
    type?: ToastType;
}

export const Toast: React.FunctionComponent<IToastProps> = (props) => {
    if (!props.visible) {
        return null;
    }
    const type = props.type || "success";
    const errorClass = type === "error" ? " toast__container--error" : "";
    const iconClass = type === "error" ? "toast__icon--error" : "toast__icon--success";
    const role = type === "error" ? "alert" : "status";
    const ariaLive = type === "error" ? "assertive" : "polite";

    return <div className={`toast__container${errorClass}`}
                data-testid="toast__container"
                role={role}
                aria-live={ariaLive}>
        <span className={iconClass} aria-hidden="true">
            {type === "error" ? "\u2717" : "\u2713"}
        </span>
        {props.message}
    </div>;
};

export default Toast;
